import React, { FC, ReactElement } from "react";
import classes from "./SocialItem.module.scss";

interface Props {
  href?: string;
  children: ReactElement<SVGElement>;
}
const SocialItem: FC<Props> = (props) => {
  if (!props.href) return null;

  return (
    <li>
      <a
        href={props.href}
        target="_blank"
        rel="noreferrer"
        className={classes.link}
      >
        <span className={classes.icon}>
          {props.children}
        </span>
      </a>
    </li>
  );
};

export default SocialItem;
